import * as firebase from 'firebase';

//dg.spushsignage.com
// let config = {
//     apiKey: "AIzaSyCrPXolGvE8ZY3q2hBqH5vX5Iv6Rv2X2hQ",
//     authDomain: "dgspushsignage.firebaseapp.com",
//     databaseURL: "https://dgspushsignage-default-rtdb.asia-southeast1.firebasedatabase.app",
//     projectId: "dgspushsignage",
//     storageBucket: "dgspushsignage.appspot.com",
//     messagingSenderId: "319608283715",
//     appId: "1:319608283715:web:311c4d790a03a7bb8c6af6",
//     measurementId: "G-5G4VCGPYGP"
// };

//makro.push-signage.com
let makroconfig = {
    apiKey: "AIzaSyALjiH89042-xLVhVOVj3nAIH0x4ps-lmg",
    authDomain: "makropushsignage.firebaseapp.com",
    databaseURL: "https://makropushsignage-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "makropushsignage",
    storageBucket: "makropushsignage.firebasestorage.app",
    messagingSenderId: "584543867924",
    appId: "1:584543867924:web:0f78ad32865f90c6390301",
    measurementId: "G-7C0QEF2T3L"
};

// re-initialize with a new config (replace default app)
export async function initFirebase(config) {
  if (firebase.apps.length) {
    // delete old default app first (must await)
    await firebase.app().delete();
  }
  firebase.initializeApp(config); // new default
  return firebase;
}


// initFirebase(makroconfig);



export default firebase;